import { render, staticRenderFns } from "./fileMessage.vue?vue&type=template&id=4ba6dffb&scoped=true"
import script from "./fileMessage.vue?vue&type=script&lang=js"
export * from "./fileMessage.vue?vue&type=script&lang=js"
import style0 from "./fileMessage.vue?vue&type=style&index=0&id=4ba6dffb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6dffb",
  null
  
)

export default component.exports